"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitAsSubPlayer = void 0;
const react_1 = __importStar(require("react"));
require("./SubmitAsSubPlayer.scss");
const SubmitAsSubPlayer_scss_json_1 = __importDefault(require("./SubmitAsSubPlayer.scss.json"));
const Player_1 = require("../shapes/Player");
const useAuth_1 = require("lincd-auth/lib/hooks/useAuth");
const SubmitAsSubPlayer = ({ selectedSubPlayer, onSubPlayerSelected, }) => {
    let auth = (0, useAuth_1.useAuth)();
    let loggedInPlayer = auth.userAccount.accountOf;
    const [subPlayers, setSubPlayers] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        Player_1.Player.getSubPlayers().then((subPlayers) => {
            if (subPlayers) {
                setSubPlayers(subPlayers);
            }
        });
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null, subPlayers && subPlayers.size > 0 && (react_1.default.createElement("div", { className: SubmitAsSubPlayer_scss_json_1.default.Root },
        react_1.default.createElement("select", { className: SubmitAsSubPlayer_scss_json_1.default.select, onChange: onSubPlayerSelected, value: selectedSubPlayer === null || selectedSubPlayer === void 0 ? void 0 : selectedSubPlayer.uri }, subPlayers.map((player) => (react_1.default.createElement("option", { key: player.uri, value: player.uri },
            player.givenName,
            " ",
            player.familyName,
            ' ',
            player.namedNode === loggedInPlayer.namedNode && '(me)')))),
        react_1.default.createElement("div", { className: SubmitAsSubPlayer_scss_json_1.default.arrow },
            react_1.default.createElement("svg", { height: "20", width: "20", viewBox: "0 0 20 20", "aria-hidden": "true", focusable: "false", className: "css-tj5bde-Svg" },
                react_1.default.createElement("path", { d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z" })))))));
};
exports.SubmitAsSubPlayer = SubmitAsSubPlayer;
//# sourceMappingURL=SubmitAsSubPlayer.js.map